const observer = new IntersectionObserver(changes => {
  for (const change of changes) {
    const { isIntersecting, target } = change;
    if (isIntersecting) {
      if (target?.tagName === 'IFRAME') {
        loadIframe(target);
      }
    }
  }
});

function loadIframe(iframe) {
  if (iframe.src) return;
  iframe.src = iframe.getAttribute('_src');
}

$('[data-intersection-observer]').each(function () {
  observer.observe(this);
});
